import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 3.5L7 10L4 7L2.5 8.5L7 13L15 5L13.5 3.5Z",
		fill: "black"
	})
});
export default SvgCheckMark;
